import { Component, Inject, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { SqlService } from "../../Database/sql.service";
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-view-agent',
  templateUrl: './view-agent.component.html',
  styleUrls: ['./view-agent.component.css']
})
export class ViewAgentComponent implements OnInit {


  SearchValue = "";

  p: number = 1;
  ItemsPerPage = 20;

  data = [
    {
      Name: "",
      Surname: "",
      CellNo: "",
      ID: "",
      Code: "",
      DistributorName: "",
      AreaName: '',
      AreaProvince: ''
    }];

  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";
  open(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult =
          `Dismissed ${this.getDismissReason(reason)}`;
      });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  constructor(private dbService: SqlService, private router: Router, private modalService: NgbModal,
    @Inject(DOCUMENT) private document: Document) { this.data.splice(0); }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    Swal.fire({
      title: 'Loading all agents',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.dbService.getAllAgents().subscribe((ret: any) => {
      if (ret != "false") {
        this.data.splice(0);
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          let elementtemp = element.split(",")
          let temp = {
            Name: elementtemp[0],
            Surname: elementtemp[1],
            CellNo: elementtemp[2],
            ID: elementtemp[3],
              Code: elementtemp[4],
              DistributorName: elementtemp[5],
              AppVisits: elementtemp[6] ? parseInt(elementtemp[6]) : 0,
              AreaName: elementtemp[7] ? elementtemp[7] : '',
              AreaProvince: elementtemp[8] ? elementtemp[8] : ''
          }
          this.data.push(temp);
        });
        Swal.close();
      } else {
        this.PopupTitle = "Something went wrong"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });
  }


  EditData(ID: string) {
    this.router.navigate(['/EditAgent', ID]);
  }

  Add() {
    this.router.navigate(['/AddAgent']);
  }

  ClearSearch() {
    this.SearchValue = "";
  }

  btnDownloadReportClickExcel() {
    /* generate worksheet */
    //var formData = new FormData(); // Currently empty 
    //formData.set("SQLQuery", "SELECT * FROM [Pactel].[dbo].[Agent]");
    let Link = '';
    if(this.document.location.hostname.includes('admin.pactel.co.za')){
      Link = "https://admin.pactel.co.za/xdt/assets/php/";
    }else{
    Link = "https://admin.pactel.co.za/xdt/assets/php/";
    }

  const params = this.SearchValue && this.SearchValue.trim() !== '' ? '?search=' + encodeURIComponent(this.SearchValue.trim()) : '';
  window.open(Link + "exportProvidedData.php" + params);

  }


}
